(function()
{
	// Include classes
	var Application = include("springroll.Application");
	var BitmapText = include("PIXI.extras.BitmapText");
	var Button = include("springroll.pixi.Button");
	var ButtonSounds = include("springroll.ButtonSounds");
	var Container = include("PIXI.Container");
	var Ease = include('createjs.Ease');
	var Sprite = include('PIXI.Sprite');
	var Texture = include('PIXI.Texture');
	var Tween = include('createjs.Tween');

	var _app;

	/**
	 * For the result text and graphics
	 * @class ScoreDisplay
	 * @extends PIXI.Container
	 */
	var ScoreDisplay = function(config)
	{
		Container.call(this);

		_app = Application.instance;

		/**
		 * Score Display configuration
		 * @property {Object} config
		 */
		this.config = config;

		/**
		 * The background display
		 * @property {PIXI.Sprite} background
		 */
		this.background = new Sprite(
			Texture.fromImage(config.background.art)
		);

		/**
		 * Display how far we've traveled
		 * @property {PIXI.BitmapText} scoreText
		 */
		this.scoreText = new BitmapText("", config.scoreText.style);
		this.scoreText.setPivotToAlign = true;
		setPosition(this.scoreText, config.scoreText);

		/**
		 * Display how far we've traveled
		 * @property {PIXI.BitmapText} scoreLabel
		 */
		this.scoreLabel = new BitmapText("FT", config.scoreLabel.style);
		this.scoreLabel.setPivotToAlign = true;
		setPosition(this.scoreLabel, config.scoreLabel);

		/**
		 * Display maximum distance we've traveled
		 * @property {PIXI.BitmapText} highScoreText
		 */
		this.highScoreText = new BitmapText("", config.highScoreText.style);
		this.highScoreText.setPivotToAlign = true;
		setPosition(this.highScoreText, config.highScoreText);

		/**
		 * The Unit lable for the distance
		 * @property {PIXI.BitmapText} highScoreLabel
		 */
		this.highScoreLabel = new BitmapText("FT", config.highScoreLabel.style);
		this.highScoreLabel.setPivotToAlign = true;
		setPosition(this.highScoreLabel, config.highScoreLabel);

		/**
		 * The button to restart
		 * @property {springroll.pixi.Button} restartButton
		 */
		var restartButton = ScoreDisplay.restartButton = this.restartButton = new Button(config.restartButton.art);
		this.buttonSounds = new ButtonSounds(
			"ButtonSelect",
			"ButtonRollover", //¶
			[restartButton]);

		this.onRestart = this.onRestart.bind(this);
		restartButton.on("buttonPress", this.onRestart);
		setPosition(restartButton, config.restartButton);
		restartButton.wiggle = function(wiggle)
		{
			Tween.removeTweens(restartButton);
			if (!wiggle)
			{
				return;
			}

			var origX = restartButton.x;
			Tween.get(restartButton,
			{
				loop: true
			}).to(
			{
				x: origX + 10
			}, 100, Ease.sineInOut).to(
			{
				x: origX - 10
			}, 100, Ease.sineInOut).to(
			{
				x: origX + 5
			}, 100, Ease.sineInOut).to(
			{
				x: origX - 5
			}, 100, Ease.sineInOut).to(
			{
				x: origX
			}, 50, Ease.backOut).to(
			{}, 500);
		};

		// Add children
		this.addChild(this.background);
		this.addChild(this.scoreText);
		this.addChild(this.scoreLabel);
		this.addChild(this.highScoreText);
		this.addChild(this.restartButton);
		this.addChild(this.highScoreLabel);

		// Hide the display
		this.hide();
	};

	// Extend the container
	var s = Container.prototype;
	var p = extend(ScoreDisplay, Container);

	// Set the position of a display object from data
	var setPosition = function(obj, data)
	{
		obj.x = data.x || 0;
		obj.y = data.y || 0;
	};

	/**
	 * Button press handler for restart button
	 * @method onRestart
	 */
	p.onRestart = function()
	{
		this.emit('restart');
	};

	/**
	 * Show the display
	 * @method show
	 * @param {String} score The current score
	 */
	p.show = function(score)
	{
		var highScoreText = this.highScoreText;
		var highScoreLabel = this.highScoreLabel;
		var scoreText = this.scoreText;
		var scoreLabel = this.scoreLabel;
		var config = this.config;
		var padding = config.scoreLabel.padding;

		scoreText.text = score;

		// Center the score text
		scoreText.x = config.scoreText.x +
			(config.scoreText.width - (scoreText.width + scoreLabel.width + padding)) / 2;

		// Position the label
		scoreLabel.x = scoreText.x +
			scoreText.width + padding;

		highScoreText.text = _app.userHighScore;
		highScoreLabel.x = highScoreText.x +
			highScoreText.width +
			config.highScoreLabel.padding;

		this.visible = true;
		this.y = -this.getLocalBounds().height;
		Tween.get(this).to(
			{
				y: -4
			},
			this.config.inTime,
			Ease[this.config.inEase]
		);
		var obj = {};

		// note: string comparison.
		if (score === _app.userHighScore)
		{
			obj.complete = function()
			{
				app.sound.play("GreatJobChime");
			};
		}
		app.sound.play("GreatJobBanner", obj);
	};

	/**
	 * hide the display
	 * @method hide
	 */
	p.hide = function()
	{
		this.visible = false;
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		this.restartButton.off("buttonPress", this.onRestart);
		Tween.removeTweens(this);

		s.destroy.call(this, true);

		this.config = null;
		this.background = null;
		this.scoreText = null;
		this.scoreLabel = null;
		this.highScoreText = null;
		this.restartButton = null;
		this.highScoreLabel = null;

		this.buttonSounds.destroy();
	};

	// The namespace
	namespace('nature').ScoreDisplay = ScoreDisplay;

}());